import { h } from "snabbdom";
import { previewHost } from "../../editor/preview";
import { PREVIEW_LENGTH_LINES, previewLength } from "../../preview-limits";
import type { PreviewLength } from "../../preview-limits";
import type { VNode } from "snabbdom";
import type { CardSummary, Msg, ViewConfig } from "../../types";

export function viewListView(
  config: ViewConfig,
  cards: CardSummary[],
  dispatch: (msg: Msg) => void,
  depth: number
): VNode {
  // Filtering, ordering and limit are all applied server-side via CEL.
  // Legacy "preview" / "single-line" configs normalize to "short".
  const length = previewLength(config.display);

  return h("div.view-list", [
    h("div.view-list__config", viewListConfig(config)),
    h(
      "div.view-list__items",
      cards.map((card) => viewListItem(card, length, dispatch, depth))
    ),
  ]);
}

function viewListItem(
  card: CardSummary,
  length: PreviewLength,
  dispatch: (msg: Msg) => void,
  depth: number
): VNode {
  const onClick = () => dispatch({ type: "NavigateTo", id: card.id });
  return h(`div.list-item.preview-len.preview-len--${length}`, { on: { click: onClick } }, [
    previewHost(card.content, depth, dispatch, PREVIEW_LENGTH_LINES[length]),
  ]);
}

function viewListConfig(config: ViewConfig): VNode {
  const parts: VNode[] = [];
  if (config.filter) {
    parts.push(h("span.view-config__chip", `filter: ${config.filter}`));
  }
  if (config.orderBy) {
    const arrow = config.orderDesc ? " ↓" : " ↑";
    parts.push(h("span.view-config__chip", `order: ${config.orderBy}${arrow}`));
  }
  return h("div.view-config", parts);
}
